"use strict";

/**
 * Update custom file input label with selected file names
 * Bootstrap 4 requires custom JS to update the label text
 * We can delete this when we upgrade to Bootstrap 5
 */

(function() {
  document.addEventListener("change", function(e) {
    if (!e.target.matches(".custom-file-input")) return;
    
    const input = e.target;
    const label = input.nextElementSibling;
    
    if (!label || !label.classList.contains("custom-file-label")) return;
    
    const files = input.files;
    
    // Store original text on first interaction
    if (!label.dataset.originalText) {
      label.dataset.originalText = label.textContent;
    }
    
    if (!files || files.length === 0) {
      // Reset to original text
      label.textContent = label.dataset.originalText;
      return;
    }
    
    if (files.length === 1) {
      // Show the single filename
      label.textContent = files[0].name;
    } else {
      // Show count of files selected
      label.textContent = files.length + " files selected";
    }
  });
})();
